<template>
    <div id="register">
        <div class="img-box">
            <div :class="logoIcon"></div>
        </div>

        <div class="login-input">
            <div class="user-account-input">
                <van-field v-model="registerData.username" type="email" placeholder="E-mail"/>
            </div>

            <div class="mt-13 user-account-input">
                <van-field
                        v-model="registerData.verifyCode"
                        center
                        clearable
                        placeholder="Verify code">
                    <template #button>
                        <span @click="sendVerifyCode" class="verify-code" size="small"
                              type="primary">{{countDownText}}</span>
                    </template>
                </van-field>
            </div>
            <!--<div class="ml-48 mr-48 resend-tips"><span>Don't receive the e-mail?</span><span-->
                    <!--class="resend ml-16" @click="sendVerifyCode" v-show="isWaitVerifyCode">Resend</span></div>-->
            <div class="mt-13 user-account-input">
                <van-field v-model="registerData.password" placeholder="Password" type="password"/>
            </div>
            <div class="mt-13 user-account-input">
                <van-field v-model="registerData.confirmPassword" placeholder="Confirm password" type="password"/>
            </div>

            <div class="mt-20 ml-48">
                <van-checkbox v-model="registerData.privacyAgreeChecked" checked-color="#ED6A0C">
                    <div class="user-account-checkbox">
                        I agree
                        <span class="agreement">UNI-CORE User Agreement</span> and
                        <span class="agreement">UNI-CORE Privacy Agreement</span>
                    </div>
                </van-checkbox>
            </div>

            <div class="mt-40 ml-40 mr-40">
                <van-button class="mt-16 center-btn user-account-btn" block round type="primary" @click="register">
                    Register
                </van-button>
            </div>

            <div class="user-account-text mt-16 ml-40 mr-40">
                Already have an account?
                <span class="login" @click="routeLogin">log in</span>
            </div>
        </div>
    </div>
</template>

<script>
    import log from "../repository/log/log";

    import userRepository from "../repository/store/UserRepository";
    import rule from "../rule/rule"
    import apiService from "../repository/api/ApiService"

    export default {
        name    : "Register",
        data() {
            return {
                registerData    : {
                    username           : "",
                    verifyCode         : "",
                    password           : "",
                    confirmPassword    : "",
                    privacyAgreeChecked: true,
                },
                countDownText   : 'Get verify code',
                countDownSecond : 60,
                intervalId      : -1,
                isWaitVerifyCode: false
            };
        },
        methods : {
            routeLogin() {
                this.$router.replace({name: "Login"});
            },
            register() {
                const {username, password, confirmPassword} = this.registerData;

                if (!rule.email.validator(username)) {
                    return;
                }

                if (!rule.password.validator(password)) {
                    return;
                }

                if (!rule.confirmPassword.validator(confirmPassword, password)) {
                    return;
                }


                userRepository
                    .register({email: username, password})
                    .then((data) => {
                        this.$router.replace({name: "Improve"});
                    })
                    .catch((err) => {
                    });
            },

            sendVerifyCode() {
                if (this.isWaitVerifyCode) {
                    return
                }

                const {username} = this.registerData;
                if (!rule.email.validator(username)) {
                    return;
                }
                userRepository.sendEmailToRegister(username).then((data) => {
                    this.isWaitVerifyCode = true
                    clearInterval(this.intervalId)
                    this.intervalId = setInterval(() => {
                        if (this.countDownSecond < 1) {
                            this.countDownText   = 'Get verify code'
                            this.countDownSecond = 60
                            clearInterval(this.intervalId)
                            this.isWaitVerifyCode = false
                            return
                        }
                        this.countDownText = `${this.countDownSecond--}s`
                    }, 1000)
                })
            }
        },
        computed: {
            logoIcon() {
                if (location.hostname === 'dimeone.unicoreus.com') {
                    return 'logo-dime'
                } else if (location.hostname === 'app.unicoreus.com') {
                    return 'logo-unicore'
                } else {
                    return 'logo-unicore'
                }
            },
        },
        mounted() {
            log("register 加载");
        },
        destroyed() {
            clearInterval(this.intervalId)
        }
    };
</script>

<style lang="scss" scoped>
    .agreement {
        color: #f6f6f6;
        font-size: 10px;
    }

    .img-icon {
        height: 20px;
    }

    .user-account-checkbox {
        color: #999999 !important;
        font-size: 13px;
    }

    .login {
        color: #f6f6f6;
    }

    .verify-code {
        color: #F6F6F6;
    }

    .resend {
        color: #ed6a0c;
    }

    .resend-tips {
        margin-top: 13px;
        font-size: 12px;
        color: #F6F6F6;
    }
</style>